(function () {
  function initBsCoverflowCards(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.bsCoverflowReady === 'true') return;

    sectionRoot.dataset.bsCoverflowReady = 'true';

    const viewport = sectionRoot.querySelector('[data-bsc-viewport]');
    const cards = Array.from(sectionRoot.querySelectorAll('[data-bsc-card]'));

    if (!viewport || !cards.length) return;

    let active = sectionRoot.dataset.start === 'first' ? 0 : Math.floor(cards.length / 2);
    let timer = null;
    let startX = 0;
    let pointerDown = false;
    let resizeFrame = null;

    const autoplay = sectionRoot.dataset.autoplay === 'true';
    const interval = Number(sectionRoot.dataset.interval || 5000);

    function getOffset(index) {
      let offset = index - active;

      if (cards.length > 2) {
        const half = cards.length / 2;

        if (offset > half) offset -= cards.length;
        if (offset < -half) offset += cards.length;
      }

      return offset;
    }

    function getDesktopGap() {
      const value = getComputedStyle(sectionRoot).getPropertyValue('--bsc-side-gap');
      return parseFloat(value) || 260;
    }

    function setCardMetrics(card, offset) {
      const abs = Math.min(Math.abs(offset), 4);
      const sign = offset < 0 ? -1 : offset > 0 ? 1 : 0;
      const width = viewport.clientWidth || window.innerWidth;
      const mobile = window.matchMedia('(max-width: 749px)').matches;

      let x = 0;
      let y = 0;
      let scale = 1;
      let opacity = 1;

      if (abs === 0) {
        x = 0;
        y = 0;
        scale = 1;
        opacity = 1;
      } else if (mobile) {
        const firstGap = Math.min(width * 0.68, 245);
        const extraGap = width * 0.42;

        x = sign * (firstGap + ((abs - 1) * extraGap));
        y = 10 + (abs * 8);
        scale = abs === 1 ? 0.84 : abs === 2 ? 0.68 : 0.54;
        opacity = abs > 2 ? 0 : 0.96;
      } else {
        const firstGap = getDesktopGap();

        x = sign * (firstGap + ((abs - 1) * 190));
        y = 18 + (abs * 18);
        scale = abs === 1 ? 0.82 : abs === 2 ? 0.68 : abs === 3 ? 0.57 : 0.48;
        opacity = abs > 3 ? 0 : 1;
      }

      card.style.setProperty('--bsc-x', `${x}px`);
      card.style.setProperty('--bsc-y', `${y}px`);
      card.style.setProperty('--bsc-scale', scale);
      card.style.setProperty('--bsc-opacity', opacity);
      card.style.setProperty('--bsc-z', 100 - abs);

      card.dataset.current = abs === 0 ? 'true' : 'false';
      card.setAttribute('aria-hidden', abs === 0 ? 'false' : 'true');
      card.style.pointerEvents = opacity === 0 ? 'none' : 'auto';
    }

    function update() {
      cards.forEach((card, index) => {
        setCardMetrics(card, getOffset(index));
      });
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || cards.length <= 1) return;

      stopAutoplay();

      timer = setInterval(function () {
        goTo(active + 1, false);
      }, interval);
    }

    function restartAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      startAutoplay();
    }

    function goTo(index, shouldRestartAutoplay) {
      if (typeof shouldRestartAutoplay === 'undefined') {
        shouldRestartAutoplay = true;
      }

      active = ((index % cards.length) + cards.length) % cards.length;
      update();

      if (shouldRestartAutoplay) {
        restartAutoplay();
      }
    }

    function move(direction) {
      goTo(active + direction);
    }

    sectionRoot.addEventListener('click', function (event) {
      const prevButton = event.target.closest('[data-bsc-prev]');
      const nextButton = event.target.closest('[data-bsc-next]');
      const viewButton = event.target.closest('.bs-coverflow__button');
      const clickedCard = event.target.closest('[data-bsc-card]');

      if (prevButton) {
        event.preventDefault();
        event.stopPropagation();
        move(-1);
        return;
      }

      if (nextButton) {
        event.preventDefault();
        event.stopPropagation();
        move(1);
        return;
      }

      /*
        Importante:
        Se clicou no botão View e ele for um link real,
        deixa o navegador abrir o link normalmente.
      */
      if (viewButton) {
        const href = viewButton.getAttribute('href');

        if (viewButton.tagName.toLowerCase() === 'a' && href && href !== '#') {
          event.stopPropagation();
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        return;
      }

      /*
        Clique no card lateral apenas centraliza o card.
      */
      if (clickedCard && clickedCard.dataset.current !== 'true') {
        event.preventDefault();
        event.stopPropagation();
        goTo(Number(clickedCard.dataset.index));
      }
    });

    viewport.addEventListener('pointerdown', function (event) {
      if (
        event.target.closest('[data-bsc-prev]') ||
        event.target.closest('[data-bsc-next]') ||
        event.target.closest('.bs-coverflow__button')
      ) {
        return;
      }

      pointerDown = true;
      startX = event.clientX;
      stopAutoplay();

      if (viewport.setPointerCapture) {
        viewport.setPointerCapture(event.pointerId);
      }
    });

    viewport.addEventListener('pointerup', function (event) {
      if (!pointerDown) return;

      const diff = event.clientX - startX;

      if (Math.abs(diff) > 38) {
        move(diff < 0 ? 1 : -1);
      } else {
        restartAutoplay();
      }

      pointerDown = false;
    });

    viewport.addEventListener('pointercancel', function () {
      pointerDown = false;
      restartAutoplay();
    });

    viewport.addEventListener('mouseenter', stopAutoplay);
    viewport.addEventListener('mouseleave', startAutoplay);

    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(update);
    });

    update();
    startAutoplay();
  }

  function initAllBsCoverflows() {
    document.querySelectorAll('.bs-coverflow').forEach(function (section) {
      section.dataset.bsCoverflowReady = 'false';
      initBsCoverflowCards(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBsCoverflows);
  } else {
    initAllBsCoverflows();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.bs-coverflow');

    if (section) {
      section.dataset.bsCoverflowReady = 'false';
      initBsCoverflowCards(section);
    }
  });
})();